








































import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';

import Card from '@/components/material/Card.vue';
import Loader from '@/components/Loader.vue';
import DlgCampaignNew from '@/modules/campaigns/_components/DlgCampaignNew.vue';
import DlgCampaignDelete from '@/modules/campaigns/_components/DlgCampaignDelete.vue';

@Component({
  components: {
    DlgCampaignDelete,
    DlgCampaignNew,
    Loader,
    Card,
  },
  filters: {
    type(val: any) {
      switch (val) {
        case 'internal':
          return 'Intern';
        case 'external':
          return 'Extern';
        default:
          return '';
      }
    },
  },
})
export default class CampaignsList extends Vue {
  @Getter('campaigns/all') private campaigns!: any[];
  @Action('campaigns/read') private readAll!: any;
  private dlgDelete: boolean = false;
  private selected: any = {};

  private loading: boolean = false;

  private async created() {
    this.loading = true;
    await this.readAll();
    this.loading = false;
  }

  private deleteCampaign(campaign: any) {
    this.selected = JSON.parse(JSON.stringify(campaign));
    this.dlgDelete = true;
  }
}
